import './instance';

// register create function for bundleid
Oskari.bundle('asdi-login', function () {
  return Oskari.clazz.create('Oskari.asdi.login.BundleInstance', 'asdi-login', 'Oskari.asdi.login.Flyout');
});